// V2 KP Rebuild : fiche produit.
// 1. v2-packs : résolution des paliers (Offre, Voitures, Coloris) sur les variantes RÉELLES ; rien n'est inventé.
// 2. Achat : interception du formulaire principal ; ajout de la variante exacte par /cart/add.js, puis redirection
//    vers /checkout (réglage v2_atc_mode = checkout) ou /cart. Bouton bloqué pendant l'opération (pas de double ajout),
//    erreurs affichées sous le bouton, panier existant jamais modifié, aucune confirmation d'achat avant paiement.
// 3. v2-sticky-atc : barre collante synchronisée avec la variante de la fiche, dans les deux sens.

const readVariants = (sectionId) => {
  const el = document.getElementById(`V2Variants-${sectionId}`);
  try { return el ? JSON.parse(el.textContent) : []; } catch (e) { return []; }
};
const sameSet = (a, b) => a.length === b.length && a.every((x) => b.includes(x)) && new Set(a).size === a.length;

function emitVariant(sectionId, variant, source, car = null) {
  document.dispatchEvent(new CustomEvent('v2:variant-change', { detail: { sectionId, variant, source, car } }));
}

// Met à jour le bloc prix de Dawn : texte immédiat, puis rendu exact de la section (prix barré éventuel compris).
let priceRequest = 0;
async function refreshPrice(sectionId, variant) {
  const box = document.getElementById(`price-${sectionId}`);
  if (!box || !variant) return;
  box.querySelectorAll('.price__regular .price-item--regular').forEach((e) => { e.textContent = variant.price_html; });
  const ticket = ++priceRequest;
  try {
    const res = await fetch(`${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`);
    const html = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = html.getElementById(`price-${sectionId}`);
    if (fresh && ticket === priceRequest) box.innerHTML = fresh.innerHTML;
  } catch (e) { /* le texte immédiat reste affiché */ }
}

function setUrlVariant(id) {
  const url = new URL(window.location.href);
  url.searchParams.set('variant', id);
  window.history.replaceState({}, '', url.toString());
}

/* ------------------------------------------------------------------ */
/* 1. Paliers                                                          */
/* ------------------------------------------------------------------ */
if (!customElements.get('v2-packs')) {
  customElements.define(
    'v2-packs',
    class V2Packs extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.variants = readVariants(this.sectionId);
        this.form = document.getElementById(this.dataset.form);
        this.oi = Number(this.dataset.offerIndex);
        this.ci = Number(this.dataset.carsIndex);
        this.ki = Number(this.dataset.colorIndex);
        this.sep = this.dataset.sep || ' + ';
        this.message = this.querySelector('[data-v2-message]');
        this.tiers = [...this.querySelectorAll('[data-v2-tier]')];
        this.offers = this.tiers.map((t) => t.dataset.v2Tier);

        // voitures individuelles, dans l'ordre d'apparition (variantes à une voiture d'abord)
        const split = (v) => (this.ci >= 0 ? v.options[this.ci].split(this.sep).map((s) => s.trim()) : []);
        const sorted = [...this.variants].sort((a, b) => split(a).length - split(b).length);
        this.carList = [];
        sorted.forEach((v) => split(v).forEach((c) => { if (!this.carList.includes(c)) this.carList.push(c); }));
        this.slotsByOffer = {};
        this.offers.forEach((o) => {
          const vs = this.variants.filter((v) => v.options[this.oi] === o);
          this.slotsByOffer[o] = vs.length ? Math.max(...vs.map((v) => split(v).length)) : 0;
        });
        this.split = split;

        const initial = this.variants.find((v) => String(v.id) === String(this.dataset.initial)) || this.variants[0];
        this.fromVariant(initial);

        this.addEventListener('change', (e) => {
          const t = e.target;
          if (t.matches('[data-v2-offer]')) this.selectOffer(t.value);
          else if (t.matches('[data-v2-color]')) { this.state.color = t.value; this.update(); }
          else if (t.matches('[data-v2-car]')) this.selectCar(Number(t.dataset.v2Car), t.value);
        });
        document.addEventListener('v2:select-variant', (e) => {
          if (e.detail?.sectionId !== this.sectionId) return;
          const v = this.variants.find((x) => String(x.id) === String(e.detail.id));
          if (v) this.fromVariant(v, 'sticky');
        });
        this.update('init');
      }

      fromVariant(v, source) {
        this.state = {
          offer: v.options[this.oi],
          cars: this.split(v),
          color: this.ki >= 0 ? v.options[this.ki] : null,
        };
        this.querySelectorAll('[data-v2-offer]').forEach((r) => { r.checked = r.value === this.state.offer; });
        this.querySelectorAll('[data-v2-color]').forEach((r) => { r.checked = r.value === this.state.color; });
        if (source) this.update(source);
      }

      selectOffer(offer) {
        const n = this.slotsByOffer[offer] || 0;
        const cars = this.state.cars.slice(0, n);
        for (const c of this.carList) { if (cars.length >= n) break; if (!cars.includes(c)) cars.push(c); }
        this.state = { ...this.state, offer, cars };
        this.update();
      }

      selectCar(slot, value) {
        const cars = [...this.state.cars];
        const other = cars.indexOf(value);
        if (other >= 0 && other !== slot) cars[other] = cars[slot]; // échange : deux voitures toujours différentes
        cars[slot] = value;
        this.state.cars = cars;
        this.lastCar = value; // la galerie affiche la voiture choisie dans le sélecteur #n (S32)
        this.update();
        this.lastCar = null;
      }

      resolve(offer = this.state.offer, cars = this.state.cars, color = this.state.color) {
        return this.variants.find((v) =>
          v.options[this.oi] === offer &&
          (this.ci < 0 || sameSet(this.split(v), cars)) &&
          (this.ki < 0 || v.options[this.ki] === color));
      }

      renderSlots() {
        this.tiers.forEach((tier) => {
          const selected = tier.dataset.v2Tier === this.state.offer;
          tier.classList.toggle('is-selected', selected);
          const box = tier.querySelector('[data-v2-slots]');
          box.innerHTML = '';
          if (!selected || this.ci < 0) return;
          const n = this.slotsByOffer[this.state.offer];
          if (n >= this.carList.length) {
            const p = document.createElement('p');
            p.className = 'v2-tier__incluses';
            p.textContent = `Incluses : ${this.state.cars.join(', ')}`;
            box.append(p);
            return;
          }
          for (let i = 0; i < n; i++) {
            const row = document.createElement('div');
            row.className = 'v2-tier__slot';
            const id = `V2Car-${this.sectionId}-${i}`;
            const label = document.createElement('label');
            label.htmlFor = id;
            label.className = 'v2-tier__slot-num';
            label.textContent = `#${i + 1}`;
            const wrap = document.createElement('div');
            wrap.className = 'v2-tier__select';
            const sel = document.createElement('select');
            sel.id = id;
            sel.dataset.v2Car = String(i);
            sel.setAttribute('aria-label', `Voiture ${i + 1}`);
            this.carList.forEach((c) => {
              const o = document.createElement('option');
              o.value = c; o.textContent = c; o.selected = this.state.cars[i] === c;
              sel.append(o);
            });
            wrap.append(sel);
            row.append(label, wrap);
            box.append(row);
          }
        });
      }

      update(source) {
        this.renderSlots();
        const v = this.resolve();
        const colorLabel = this.querySelector('[data-v2-color-label]');
        if (colorLabel && this.state.color) colorLabel.textContent = this.state.color;

        // prix de chaque palier : variante résolue pour le palier choisi, sinon variante la moins chère de ce palier (même coloris)
        this.tiers.forEach((tier) => {
          const offer = tier.dataset.v2Tier;
          let tv = offer === this.state.offer ? v : null;
          if (!tv) {
            const pool = this.variants.filter((x) => x.options[this.oi] === offer && (this.ki < 0 || x.options[this.ki] === this.state.color));
            tv = pool.sort((a, b) => a.price - b.price)[0];
          }
          if (!tv) return;
          tier.querySelector('[data-v2-tier-price]').textContent = tv.price_html;
          // S41 : prix barré et pourcentage ensemble, seulement si compare_at_price réel et autorisé (tv.compare vaut 0 sinon)
          const s = tier.querySelector('[data-v2-tier-compare]');
          const pct = tier.querySelector('[data-v2-tier-pct]');
          const box = tier.querySelector('[data-v2-tier-reduc]');
          const on = tv.compare > tv.price;
          if (s) s.textContent = on ? tv.compare_html : '';
          if (pct) pct.textContent = on ? `−${Math.round(((tv.compare - tv.price) / tv.compare) * 100)} %` : '';
          if (box) box.hidden = !on;
        });

        const input = this.form?.querySelector('input[name="id"]');
        const ok = !!v && v.available;
        this.valid = ok;
        this.currentId = ok ? v.id : null;
        if (input) {
          if (ok) { input.value = v.id; input.disabled = false; } else { input.disabled = true; }
        }
        // S41 : formulaire du paiement en plusieurs fois (Shop Pay) aligné sur la même variante
        const inst = document.querySelector(`#product-form-installment-${this.sectionId} input[name="id"]`);
        if (inst && ok) inst.value = v.id;
        setAddButtons(this.sectionId, ok, ok ? null : (v ? 'Cette combinaison est épuisée.' : 'Cette combinaison n\'existe pas. Choisissez d\'autres voitures.'));
        if (this.message) {
          this.message.hidden = ok;
          this.message.textContent = ok ? '' : (v ? 'Cette combinaison est épuisée.' : 'Cette combinaison n\'existe pas.');
        }
        if (ok) {
          if (source !== 'init') { refreshPrice(this.sectionId, v); setUrlVariant(v.id); }
          emitVariant(this.sectionId, v, source || 'packs', this.lastCar || null);
        }
      }
    }
  );
}

/* ------------------------------------------------------------------ */
/* 2. Achat                                                            */
/* ------------------------------------------------------------------ */
function addButtons(sectionId) {
  return [document.getElementById(`ProductSubmitButton-${sectionId}`), ...document.querySelectorAll(`v2-sticky-atc[data-section="${sectionId}"] [data-v2-sticky-add]`)].filter(Boolean);
}
function setAddButtons(sectionId, enabled) {
  addButtons(sectionId).forEach((b) => {
    if (b.dataset.v2Busy) return;
    b.disabled = !enabled;
    b.setAttribute('aria-disabled', String(!enabled));
  });
}
function showError(form, text) {
  const root = form.closest('product-form') || form.parentElement;
  const wrap = root?.querySelector('.product-form__error-message-wrapper');
  const msg = root?.querySelector('.product-form__error-message');
  if (wrap && msg) { msg.textContent = text; wrap.hidden = !text; }
}

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;
  const info = form.closest('product-info[data-v2-pdp]');
  if (!info) return;
  // la logique d'ajout de Dawn ne s'exécute pas : un seul ajout, contrôlé ici
  event.preventDefault();
  event.stopImmediatePropagation();
  if (form.dataset.v2Busy) return;

  const sectionId = info.dataset.section;
  const variants = readVariants(sectionId);
  const input = form.querySelector('input[name="id"]');
  const id = Number(input?.value);
  const variant = variants.find((v) => v.id === id);
  const packs = info.querySelector('v2-packs');
  showError(form, '');
  if (!variant || !variant.available || input.disabled || (packs && (!packs.valid || packs.currentId !== id))) {
    showError(form, 'Choisissez une formule disponible avant de continuer.');
    return;
  }

  const items = [{ id, quantity: 1 }];
  info.querySelectorAll('[data-v2-addon]').forEach((sw) => { if (sw.checked) items.push({ id: Number(sw.dataset.v2Addon), quantity: 1 }); });

  const buttons = addButtons(sectionId);
  form.dataset.v2Busy = '1';
  buttons.forEach((b) => {
    b.dataset.v2Busy = '1';
    b.disabled = true;
    b.setAttribute('aria-disabled', 'true');
    b.setAttribute('aria-busy', 'true');
    b.classList.add('loading');
    b.querySelector('.loading__spinner')?.classList.remove('hidden');
  });
  const release = () => {
    delete form.dataset.v2Busy;
    buttons.forEach((b) => {
      delete b.dataset.v2Busy;
      b.disabled = false;
      b.setAttribute('aria-disabled', 'false');
      b.removeAttribute('aria-busy');
      b.classList.remove('loading');
      b.querySelector('.loading__spinner')?.classList.add('hidden');
    });
  };

  try {
    const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Ajout impossible. Réessayez.');
    const added = Array.isArray(data.items) ? data.items.map((i) => i.variant_id) : [data.variant_id];
    if (!added.includes(id)) throw new Error('La réponse de la boutique ne correspond pas à la variante choisie.');

    const mode = info.dataset.v2AtcMode === 'cart' ? 'cart' : 'checkout';
    const target = mode === 'checkout' ? '/checkout' : (window.routes?.cart_url || '/cart');
    // si la redirection n'aboutit pas, l'article reste dans le panier et le client est prévenu
    window.setTimeout(() => {
      release();
      showError(form, '');
      const wrap = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      const msg = form.closest('product-form')?.querySelector('.product-form__error-message');
      if (wrap && msg) { msg.innerHTML = 'Votre article est dans le panier. <a href="/cart">Ouvrir le panier</a>'; wrap.hidden = false; }
    }, 12000);
    window.location.assign(target);
  } catch (err) {
    release();
    showError(form, err.message);
  }
}, true);

/* ------------------------------------------------------------------ */
/* 3. Barre collante                                                   */
/* ------------------------------------------------------------------ */
if (!customElements.get('v2-sticky-atc')) {
  customElements.define(
    'v2-sticky-atc',
    class extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.form = document.getElementById(this.dataset.form);
        this.variants = readVariants(this.sectionId);
        this.select = this.querySelector('[data-v2-sticky-select]');
        this.price = this.querySelector('[data-v2-sticky-price]');
        this.button = this.querySelector('[data-v2-sticky-add]');
        const main = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.hidden = false;
        this.setAttribute('aria-hidden', 'true');

        this.button?.addEventListener('click', () => { if (this.form && !this.button.disabled) this.form.requestSubmit(); });
        this.select?.addEventListener('change', () => this.choose(this.select.value));
        document.addEventListener('v2:variant-change', (e) => {
          if (e.detail?.sectionId === this.sectionId && e.detail.source !== 'sticky-self') this.show(e.detail.variant);
        });
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
            if (e.data?.sectionId !== this.sectionId || !e.data.variant) return;
            const v = this.variants.find((x) => x.id === e.data.variant.id);
            if (v) this.show(v);
          });
        }

        // Visible quand le bouton principal est dépassé (au-dessus de l'écran). Contrôle de position au défilement :
        // un IntersectionObserver ne signale rien lors d'un saut direct de « sous l'écran » à « au-dessus ».
        this.inert = true;
        let raf = 0;
        const check = () => {
          raf = 0;
          this.placeUnderHeader();
          const btn = document.getElementById(`ProductSubmitButton-${this.sectionId}`) || main;
          const passed = !!btn && btn.getBoundingClientRect().bottom < 0;
          if (passed === this.classList.contains('is-visible')) return;
          this.classList.toggle('is-visible', passed);
          this.setAttribute('aria-hidden', String(!passed));
          this.inert = !passed;
        };
        const schedule = () => { if (!raf) raf = requestAnimationFrame(check); };
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule, { passive: true });
        check();
      }

      placeUnderHeader() {
        const header = document.querySelector('.header-wrapper');
        const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        this.style.setProperty('--v2-sticky-top', `${Math.round(bottom)}px`);
      }

      show(v) {
        if (!v) return;
        if (this.price) this.price.textContent = v.price_html;
        if (this.select) this.select.value = String(v.id);
      }

      choose(id) {
        const v = this.variants.find((x) => String(x.id) === String(id));
        if (!v) return;
        this.show(v);
        const packs = document.querySelector(`v2-packs[data-section="${this.sectionId}"]`);
        if (packs) {
          document.dispatchEvent(new CustomEvent('v2:select-variant', { detail: { sectionId: this.sectionId, id: v.id } }));
          return;
        }
        // sélecteur natif de Dawn : on choisit les valeurs d'options correspondantes
        const selects = document.querySelector(`#MainProduct-${this.sectionId} variant-selects`);
        if (!selects) return;
        const fieldsets = [...selects.querySelectorAll('fieldset')];
        v.options.forEach((value, i) => {
          const scope = fieldsets[i] || selects;
          const radio = [...scope.querySelectorAll('input[type="radio"]')].find((r) => r.value === value);
          if (radio && !radio.checked) radio.click(); // sélection native : Dawn recalcule la variante
          const sel = selects.querySelectorAll('select')[i];
          if (sel && sel.value !== value) { sel.value = value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
        });
      }
    }
  );
}

/* ------------------------------------------------------------------ */
/* 4. S42 : aperçu interne, « Stock : X » selon le coloris ou le modèle   */
/* ------------------------------------------------------------------ */
{
  const role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
  const apercu = !!role && role !== 'main' && new URLSearchParams(window.location.search).get('s42_apercu') === '1';
  if (apercu) document.querySelectorAll('[data-s42-apercu]').forEach((el) => { el.hidden = false; });
  // « Livraison pour Noël » : retirée le lendemain de la date limite, même si la page vient du cache (heure de Paris)
  const aujourdhui = new Date().toLocaleDateString('sv-SE', { timeZone: 'Europe/Paris' });
  document.querySelectorAll('.v2-noel[data-limite]').forEach((el) => { if (aujourdhui > el.dataset.limite) el.hidden = true; });

  document.querySelectorAll('[data-v2-stock]').forEach((el) => {
    const index = Number(el.dataset.index);
    if (index < 0) return; // valeur unique : aucun changement selon les choix du client
    const n = el.querySelector('[data-v2-stock-n]');
    const table = Object.fromEntries(String(el.dataset.valeurs).split('|').map((x) => x.split('=').map((y) => y.trim())));
    const afficher = (valeur) => {
      const q = table[valeur];
      if (q === undefined) { el.hidden = true; return; } // valeur non renseignée : rien plutôt qu'un chiffre faux
      n.textContent = q;
      if (!el.hasAttribute('data-s42-apercu') || apercu) el.hidden = false;
    };
    const lire = (v) => { if (v && Array.isArray(v.options) && v.options[index] !== undefined) afficher(v.options[index]); };
    document.addEventListener('v2:variant-change', (e) => { if (e.detail?.sectionId === el.dataset.section) lire(e.detail.variant); });
    document.addEventListener('change', (e) => { if (e.target.matches && e.target.matches('[data-v2-color]') && table[e.target.value] !== undefined) afficher(e.target.value); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => { if (e.data?.sectionId === el.dataset.section) lire(e.data.variant); });
    }
  });
}
